module.exports = __webpack_public_path__ + "static/media/logo_large.cfa38e46.png";